<template>
  <div class="default-layouts" style="background-color: #f4f6f9">
    <Nav />

    <slot />

    <Footer />
  </div>
</template>

<script setup>
import Nav from '~/components/layout/nav.vue'
import Footer from '~/components/layout/footer.vue'
</script>

<style lang="scss" scoped>
.base-nav-container {
  background: url('~/assets/images/header-bgs/index-nav-bg.jpg') no-repeat #2a2d3c;
  border-color: #2a2d3c;
  box-shadow: #12182c 0px 0px 5px;
}
</style>